import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import state from '../store/index.js'
import { getSetting } from '../api/index.js'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta:{
			title: '首页',
			// auth:false
		}
	},
	// {
	// 	path:'/posts',
	// 	name:'PostsTest',
	// 	component:()=>import('../views/Posts/Posts.vue'),
	// 	meta:{
	// 		title: '文章',
	// 		// auth:false
	// 	}
	// },
	{
		path:'/posts/:uuid([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})',
		name: 'Posts',
		component: () => import('../views/Posts/Posts.vue'),
		meta:{
			title: '文章',
			// auth:false
		}
	},
	{
		path:"/info",
		name:"Info",
		component:()=>import('../views/Info/Info.vue'),
		meta:{
			title: '资讯',
			// auth:false
		},
	},
	{
		name: "InfoDetail",
		path: "/info/detail",
		component: ()=>import("../views/InfoDetail/InfoDetail.vue"),
		meta: {
			title: "详情",
			// auth: false
		}
	},
	{
		name:"Contest",
		path: "/contest",
		component:()=>import('../views/Contest/Contest.vue'),
		meta:{
			title: '大赛',
			// auth:false
		}
	},
	{
		path: "/contest/detail/:uuid([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})",
		name: "ContestDetail",
		component: () => import('../views/ContestDetail/ContestDetail.vue'),
		meta: {
			title: "大赛详情",
			// auth: false
		}
	},
	{
		path: "/commitment",
		name: "CommitmentDetail",
		component: () => import('../views/ContestDetail/Commitment.vue'),
		meta: {
			title: "11",
			// auth: false
		}
	},
	{
		name:"UserProfile",
		path:"/userProfile/:code",
		component:() => import("../views/UserProfile/Profile.vue"),
		meta:{
			title:"设计师主页"
		}
	},
	{
		name:"Search",
		path:"/search/:keyword",
		component: () => import("../views/Search/Search.vue"),
		meta: {
			title: "搜索结果",
			// auth: false
		}
	},
	{
		name:"UserAppeal",
		path:"/Appeal/Appeal",
		component: () => import("../views/Appeal/Appeal.vue"),
		meta: {
			title: "侵权申诉",
			// auth: false
		}
	},
	{
		name:"BusinessCooperation",
		path:"/BusinessCooperation/BusinessCooperation",
		component:()=>import('../views/BusinessCooperation/BusinessCooperation.vue'),
		meta:{
			title:"商务合作"
		}
	},
	{
		path: "/workbench",
		name: "WorkBench",
		component: () => import('../views/WorkBench/Layout.vue'),
		redirect: '/workbench/home',
		children: [
			{
				name: "WorkBenchHome",
				path: "home",
				component: () => import("../views/WorkBench/Home.vue"),
				meta: {
					title: "我的工作台",
					// auth: true
				}
			},
			{
				name: "WorkBenchMyTemplate",
				path: "template",
				component: () => import("../views/WorkBench/MyTemplate.vue"),
				meta: {
					title: "我的款式",
					// auth: true
				}
			},
			{
				name: "OrderCenter",
				path: "/order/center",
				component: () => import("../views/Order/Center.vue"),
				meta: {
					title: "我的订单",
					// auth: true
				}
			},
			{
				name: "OrderDetail",
				path: "/order/detail",
				component: () => import("../views/Order/Detail.vue"),
				meta: {
					title: "订单详情",
					// auth: true
				}
			},
			{
				name:'MyCreations',
				path:'creations',
				component:() => import('../views/WorkBench/MyCreations.vue'),
				meta:{
					title:'我的笔记'
				}
			},
			{
				name:"MyFollow",
				path:"fansfollow/:type",
				component:() => import('../views/WorkBench/FansFollow.vue'),
				meta:{
					title:'我的关注'
				}
			},
			{
				name:"MyFans",
				path:"fansfollow/:type",
				component:() => import('../views/WorkBench/FansFollow.vue'),
				meta:{
					title:'我的粉丝'
				}
			},
			{
				name:'OpenShop',
				path:'openShop',
				component:() => import('../views/WorkBench/OpenShop.vue'),
				meta:{
					title:'平台店铺'
				}
			},
			{
				name: "UserCenter",
				path: "center",
				component: () => import("../views/User/Center.vue"),
				meta: {
					title: "个人中心",
					// auth: true
				}
			},
		]
	},
	{
		path: "/workbench/design",
		name: "WorkBenchDesign",
		component: () => import('../views/WorkBench/DesignV3/Main.vue'),
		meta: {
			title: "创建设计",
			auth: true
		}
	},
	{
		path:"/workbench/quickdesign",
		name:"QuickDesign",
		component:()=>import('../views/WorkBench/QuickDesign.vue'),
		meta:{
			title:"Quick-Design",
			auth:true
		}
	},
	{
		path:"/workbench/modify_order_design",
		name:"ModifyDesign",
		component:()=>import('../views/Order/ModifyDesign.vue'),
		meta:{
			title:"Modify-Design",
			auth:true
		}
	},
	{
		path: "/workbench/summary",
		name: "WorkBenchSummary",
		component: () => import('../views/WorkBench/Summary.vue'),
		meta: {
			title: "款式确定页",
			auth: true
		}
	},
	{
		path: "/summary_outer",
		name: "WorkBenchSummaryOuter",
		component: () => import('../views/WorkBench/SummaryOuter.vue'),
		meta: {
			title: "订单信息",
			auth: false
		}
	},
	{
		path: "/order/checkout",
		name: "WorkBenchCheckout",
		component: () => import('../views/Order/Checkout.vue'),
		meta: {
			title: "订单确认页",
			auth: true
		}
	},
	{
		path: "/order/cashdesk",
		name: "CashDesk",
		component: () => import('../views/Order/CashDesk.vue'),
		meta: {
			title: "正在支付",
			auth: true
		}
	},
	{
		path: "/order/makeup",
		name: "Makeup",
		component: () => import('../views/Order/Makeup.vue'),
		meta: {
			title: "正在支付",
			auth: true
		}
	},
	{
		path: "/order/result",
		name: "PayResult",
		component: () => import('../views/Order/PayResult.vue'),
		meta: {
			title: "支付结果",
			auth: false
		}
	},
	{
		name: "ShopHome",
		path: "/shop/home",
		component: () => import("../views/Shop/Home.vue"),
		meta: {
			title: "我的店铺",
			auth: false
		}
	},
	{
		name:'ShopManage',
		path:'/shop/manage',
		component:()=>import('../views/Shop/Product/Manage.vue'),
		meta:{
			title:"商品管理",
			auth:true
		}
	},
	{
		name: "ProductEdit",
		path: "/shop/product/edit",
		component: () => import("../views/Shop/Product/Edit.vue"),
		meta: {
			title: "商品维护",
			auth: true
		}
	},
	{
		name: "ProductDetail",
		path: "/shop/product/detail",
		component: () => import("../views/Shop/Product/Detail.vue"),
		meta: {
			title: "商品详情",
			auth: false
		}
	},
	{
		name: "FabricDetail",
		path: "/order/fabric_detail",
		component: () => import("../views/Order/FabricDetail.vue"),
		meta: {
			title: "面料详情单",
			// auth: true
		}
	},
	{
		path: "/register",
		name: "Register",
		component: () => import('../views/Auth/Register.vue'),
		meta: {
			title: "注册",
			auth: false
		}
	},
	{
		path: "/login",
		name: "Login",
		component: () => import('../views/Auth/Login.vue'),
		meta: {
			title: "登录",
			auth: false
		}
	},
	{
		path: "/findpwd",
		name: "FindPwd",
		component: () => import('../views/Auth/FindPwd.vue'),
		meta: {
			title: "找回密码",
			auth: false
		}
	},
	{
		path:"/submit-result",
		name:"SubmitResult",
		component: () => import('../views/SubmitResult/SubmitResult.vue'),
		meta:{
			title:"提交成功",
			auth:false
		}
	},
	{
		path:'/:uuid([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})',
		name:'PostDetail',
		component:Home,
		meta:{
			title:''
		}
	},
]

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location){
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function(location){
  return originalReplace.call(this, location).catch(err => err);
};

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 总是滚动到顶部
		return { x: 0, y: 0 };

		// 或者如果你希望恢复之前保存的位置（如浏览器前进/后退）
		// return savedPosition || { x: 0, y: 0 };
	}
})
router.beforeEach(async (to, from, next) => {
	await state.dispatch('checkExpiredTime');
	//检查是否加载了配置
	if (!state.getters.isSettingLoad()) {
		getSetting({}).then(response => {
			state.commit("updateSetting", response.data)
		})
	}
	// 检查登录状态
	if (to.matched.some(record => record.meta.auth)) {
		if (state.getters.isLoginDynamic()) {
			next()
		} else {
			state.commit('update_login_state', false)
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		next()
	}
})

export default router
